var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voice-img",style:({width:_vm.width?_vm.width:'28px'}),on:{"click":_vm.clickVoice}},[_vm._t("default"),(!_vm.isRecording)?_c('img',{attrs:{"src":require("../../assets/images/voice/voice.png"),"alt":""}}):_c('img',{attrs:{"src":require("../../assets/images/voice/voice.gif"),"alt":""}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }